import gql from 'graphql-tag';

const CreateCourtApplication = gql`
  mutation CREATE_COURT_APPLICATION_MUTATION(
    $input: CreateCourtApplicationMutationInput!
  ) {
    createCourtApplication(input: $input) {
      courtApplication {
        id
        sections
      }
    }
  }
`;

export { CreateCourtApplication };



// WEBPACK FOOTER //
// ./src/mutations/CreateCourtApplication.js